<template>
<div class="grantCodeDialog">
    <el-dialog title="短信发送" :visible.sync="dialogVisible" width="484px" @close="cancel" :close-on-click-modal="false">
        <div class="tip flexstart"><span>账户余额：￥{{balancebycanuse}}</span><span class="cursor tc-blue rechange" @click="handleRecharge">去充值 ></span></div>
        <el-form :model="item" :rules="rules" ref="formName" label-width="80px" class="demo-item" label-position="left" size="mini">
            <el-form-item label="手机号码" prop="mobileno" class="">
                <el-input v-model.trim="item.mobileno" placeholder="" clearable @blur="getUserinfo"></el-input>
            </el-form-item>
            <el-form-item label="兑换用户" prop="subject" class="">
                <div v-if="!init">--</div>
                <div class="flexstart" v-if="user.iscustomer && init">
                    <div class="img-box"><img :src="user.logourl" alt="" class="img"></div>
                    <div class="username">{{user.name}}</div>
                </div>
                <div class="tc-red" v-if="!user.iscustomer && init">无法查询该会员用户信息！</div>
            </el-form-item>
            <el-form-item label="短信内容" prop="smsContent">
                <el-input type="textarea" v-model="item.smsContent"  placeholder="请输入通知内容" maxlength="100" show-word-limit :rows="5"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="handleSure" :disabled="!user.iscustomer">确 定</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import {mapActions} from 'vuex'
import {sendTredeemCodeInfo , getCwCustomerInfoByMobileno, getCustomerBalanceInfo} from 'api/operateToolApi'
export default {
    name: 'grantCodeDialog',
    data() {
        return {
            dialogVisible: false,
            item: {
                codedetailid: '',
                mobileno: '',
                smsContent: ''
            },
            balancebycanuse: '',
            init: false,
            user: {
                iscustomer: '', // 1会员
                logourl:'',
                name:'',
            },
            rules: {
                mobileno: [
                    {required: true, message: '请输入手机号', trigger: 'blur'},
                    {pattern: /^1[0-9]{10}$/, message: '请输入正确的手机号（11位）', trigger: 'blur'}
                ],
                smsContent: [
                    {required: true, message: '请输入短信内容', trigger: 'blur'},
                ]
            }
        }
    },
    mounted() {
    },
    methods: {
        handleRecharge() {
            let newurl = this.$router.resolve({
                name: 'Balance'
            })
            window.open(newurl.href, '_blank')
        },
        handleSure() {
            this.$refs.formName.validate((valid, name) => {
                if (valid) {
                    this._sendTredeemCodeInfo()
                }
            })
        },
        cancel() {
            this.init = false
            this.user = {
                logourl:'',
                name:'',
            }
            this.$refs.formName.resetFields()
            this.dialogVisible = false
        },
        openDialog(row, param) {
            this.item.codedetailid = row.codedetailid
            let kmcname = param.kmcname.length > 20 ? param.kmcname.substring(0, 20) + '...' : param.kmcname
            this.item.smsContent = `尊敬的用户请打开资鲸网App，使用 ${row.codevalue} 兑换《${kmcname}》`
            this.dialogVisible = true
            this._getBalance()
        },
        getUserinfo() {
            if (/^1[0-9]{10}$/.test(this.item.mobileno)) {
                this.setLoading(true)
                getCwCustomerInfoByMobileno ({
                    data: {mobileno: this.item.mobileno},
                    success: data => {
                        this.init = true
                        this.user = data.data
                        this.setLoading(false)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            }
        },
        _sendTredeemCodeInfo() {
            this.setLoading(true)
            sendTredeemCodeInfo ({
                data: this.item,
                success: data => {
                    this.$message.success('短信发送成功！')
                    this.setIsRefresh(1)
                    this.$emit('refresh')
                    this.cancel()
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getBalance() {
            this.setLoading(true)
            getCustomerBalanceInfo({
                data: {},
                success: data => {
                    this.balancebycanuse = data.data.balancebycanuse
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading', 'setIsRefresh'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.grantCodeDialog {
    font-size: 14px;
    .el-dialog__body{
        padding: 0 !important;
    }
    .tip{
        margin-bottom: 20px;
        background: #FDF6EC;
        height: 50px;
        padding: 0 20px;
        .rechange{
            margin-left: 30px;
        }
    }
    .el-form{
        margin: 0 20px;
    }
    .img-box{
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin-right: 10px;
        .img{
            width: 100%;
            height: 100%;
            border-radius: 50%;
        }
    }
    textarea{
        resize: none;
        width: 100%;
    }
}
</style>
